import type { ReactNode } from 'react'

/**
 * The left rail of a timeline entry: a dot (passed as children) plus the
 * connector line to the next entry. The line is omitted on the last entry.
 */
export const TimelineRail = ({
  isLast,
  children,
}: {
  isLast: boolean
  children: ReactNode
}) => (
  <div className="flex w-7 flex-col items-center gap-1.5">
    {children}
    {!isLast && <div className="w-0.5 flex-1 bg-gray-200" />}
  </div>
)
